import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    testLog: {
      info:[]
    },
  },
  mutations: {
    [types.SET_TEST_LOG](state, payload) {
      state.testLog.info = payload.info
    },

  },
  actions: {
    getTestLog({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "test-log/all"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_TEST_LOG,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
